var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "div-center v-page-center" }, [
      _c(
        "div",
        { ref: "phoneEmail", staticClass: "phone-email flex-between-center" },
        _vm._l(_vm.footer.links, function (link) {
          return _c(
            "div",
            { key: link.id, staticClass: "pe-item flex-side-center" },
            [
              _c("img", {
                staticClass: "icon",
                attrs: { src: link.icon, alt: link.label },
              }),
              _c("div", { staticClass: "flex-column flex-main-between" }, [
                _c("div", [_vm._v(_vm._s(link.value))]),
                _c("div", { staticClass: "label" }, [
                  _vm._v(_vm._s(link.label)),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "service-example flex-center" }, [
        _c(
          "div",
          {
            staticStyle: {
              "margin-right": "24px",
              "font-size": "16px",
              "font-weight": "500",
            },
          },
          [_vm._v(_vm._s(_vm.footer.serviceCases[0].label))]
        ),
        _c(
          "div",
          { staticClass: "flex-side-center" },
          _vm._l(_vm.footer.serviceCases[0].value, function (val, idx) {
            return _c(
              "span",
              { key: idx, staticStyle: { "margin-right": "24px" } },
              [_vm._v(" " + _vm._s(val) + " ")]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "copyright text-center" }, [
        _c("span", [_vm._v(_vm._s(_vm.footer.copyright.company))]),
        _c(
          "a",
          {
            staticClass: "record",
            attrs: { href: _vm.footer.copyright.record.link, target: "_blank" },
          },
          [_vm._v("  " + _vm._s(_vm.footer.copyright.record.name) + " ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }